var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.isMobile ? "text-center" : "" },
    [
      _vm.isMobile
        ? _c("SelectConversionMinutesDropdown", {
            attrs: {
              "selectable-conversion-minutes": _vm.selectableConversionMinutes,
              disabled: _vm.disabled,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "labelText",
                  fn: function () {
                    return [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("trans")("Credits")) +
                          "\n            "
                      ),
                      _c("i", {
                        staticClass:
                          "fa fa-question-circle text-info cursor-pointer",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            $event.preventDefault()
                            _vm.learnMore = !_vm.learnMore
                          },
                        },
                      }),
                      _vm._v(":\n            "),
                      _c("br"),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              946731636
            ),
            model: {
              value: _vm.selectedMinutes,
              callback: function ($$v) {
                _vm.selectedMinutes = $$v
              },
              expression: "selectedMinutes",
            },
          })
        : !_vm.isMobile
        ? _c("SelectConversionMinutesSlider", {
            attrs: {
              "selectable-conversion-minutes": _vm.selectableConversionMinutes,
              disabled: _vm.disabled,
            },
            scopedSlots: _vm._u([
              {
                key: "labelText",
                fn: function () {
                  return [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm._f("trans")("Credits")) +
                        "\n            "
                    ),
                    _c("i", {
                      staticClass:
                        "fa fa-question-circle text-info cursor-pointer",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          _vm.learnMore = !_vm.learnMore
                        },
                      },
                    }),
                    _vm._v(":\n        "),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.selectedMinutes,
              callback: function ($$v) {
                _vm.selectedMinutes = $$v
              },
              expression: "selectedMinutes",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade-grow" } }, [
        _vm.learnMore
          ? _c(
              "div",
              {
                staticClass:
                  "border px-4 py-3 mb-4 bg-white rounded position-relative mt-3",
              },
              [
                _c(
                  "span",
                  {
                    staticClass:
                      "position-absolute top-0 right-0 pt-2 font-size-150 cursor-pointer lh-1 pr-1",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        _vm.learnMore = false
                      },
                    },
                  },
                  [_vm._v("×")]
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm._f("trans")(
                          "Every API job that successfully processes files consumes Credits. One Credit is used per server processing minute or part thereof when running a job. Certain premium jobs use more Credits per minute as specified on our pricing page."
                        )
                      ) +
                      "\n            "
                  ),
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "mb-0 font-size-100 pl-2" }, [
                  _c("li", { staticClass: "py-1 px-0" }, [
                    _vm._v(_vm._s(_vm._f("trans")("All bandwidth included"))),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "py-1 px-0" }, [
                    _vm._v(_vm._s(_vm._f("trans")("High priority processing"))),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "py-1 px-0" }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("trans")("File sizes up to %fileSizeLimit%", {
                            "%fileSizeLimit%": _vm.fileSizeLimit,
                          })
                        ) +
                        "\n              "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "py-1 px-0" }, [
                    _vm._v(_vm._s(_vm._f("trans")("Support"))),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }